import { ReactElement } from 'react';
import { TabContext } from '@mui/lab';

import { TabPanelData } from '~globals/types/commons';

import { AssistantGenerateRoutesDialogTab } from '../../../types';
import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../Context';

import AssistantGenerateRoutesDialogByTemplateContentFormTab from './Form';
import AssistantGenerateRoutesDialogByTemplateContentStepperTab from './Stepper';

import {
  AssistantGenerateRoutesDialogByTemplateContentTabsContainer,
  AssistantGenerateRoutesDialogByTemplateContentTabsPanel,
} from './styles';

const TABS_PANELS: TabPanelData<AssistantGenerateRoutesDialogTab>[] = [
  {
    id: 'form',
    panel: AssistantGenerateRoutesDialogByTemplateContentFormTab,
  },
  {
    id: 'stepper',
    panel: AssistantGenerateRoutesDialogByTemplateContentStepperTab,
  },
];

const AssistantGenerateRoutesDialogByTemplateContentTabs = (): ReactElement => {
  const {
    activeTab: { tab: currentTab },
  } = useAssistantGenerateRoutesDialogByTemplateContext();

  return (
    <AssistantGenerateRoutesDialogByTemplateContentTabsContainer dividers>
      <TabContext value={currentTab}>
        {TABS_PANELS.map(({ id, panel: Panel }) => (
          <AssistantGenerateRoutesDialogByTemplateContentTabsPanel
            key={`dialog-assistant-generate-routes-by-template-panel-${id}`}
            value={id}
          >
            <Panel />
          </AssistantGenerateRoutesDialogByTemplateContentTabsPanel>
        ))}
      </TabContext>
    </AssistantGenerateRoutesDialogByTemplateContentTabsContainer>
  );
};

export default AssistantGenerateRoutesDialogByTemplateContentTabs;
